module.exports = __webpack_public_path__ + "img/red2.fe4fb542.jpg";